<template>
  <div id="intro">
    <div class="imgContainer">
      <img :src="logo" />
    </div>
    <div class="textContainer">
      <h4>Benvenuto sul chatbot di {{ brand }}</h4>
      <p>Per cominciare clicca il pulsante "inizia" o scrivi "Ciao"</p>
      <button type="button" @click="sendMessage(start)">Inizia</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "intro",
  props: ["logo", "brand"],
  data() {
    return {
      start: "Ciao!"
    };
  },
  methods: {
    sendMessage: function() {
      let message = this.start;
      this.$root.$emit("component_message", message);
    }
  }
};
</script>
<style>
#intro {
  text-align: center;
}
#intro .imgContainer {
  border-radius: 14px;
  overflow: hidden;
  width: 150px;
  height: 150px;
  margin: auto;
}
#intro .imgContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#intro .textContainer h4 {
  margin: 18px 0;
}
#intro button {
  background: #97bf0d;
  color: #fff;
  text-transform: uppercase;
  border-radius: 25px;
  border: none;
  padding: 6px 20px;
}
</style>